import React, { useState, useEffect, useContext } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';
import { checkIfObjectHasValue, getFromSessionStorage, stopBackgroundScrolling } from 'common/utils/app.utils';
import { fsProceedPopupOnLoad, fsProceedPopupOnSubmit } from 'home/view/upgrade-order/utils';
import { CONTEXT } from 'home/view/upgrade-order/context';
import { MODULE_ID } from 'home/common/constants/constants';
import { USER_TYPE } from 'common/constants/app.constants';

import './index.scss';

const CustomModal = (props) => {
  let { customPopupTitle, customPopupMsg, closeCustomPopup, submitCustomPopup, onLoad, loading = false, submitOrderPopup = false, leadData = {}, submitBtnName = 'OK' } = props;
  const appContext = useContext(CONTEXT);
  const userType = appContext?.userType || getFromSessionStorage(MODULE_ID, USER_TYPE) || 'CUSTOMER';

  const [checked, setChecked] = useState(true);

  const onCheckBoxChange = (value) => {
    setChecked(value);
  };

  const closeCustomModal = () => {
    stopBackgroundScrolling(false);
    closeCustomPopup();
  };

  const submitCustomModal = () => {
    stopBackgroundScrolling(false);
    submitCustomPopup();

    if (customPopupTitle !== 'Go Back') {
      checkIfObjectHasValue(leadData) && fsProceedPopupOnSubmit(leadData, userType);
    }
  };

  useEffect(() => {
    checkIfObjectHasValue(leadData) && fsProceedPopupOnLoad(leadData, userType);
  }, [leadData, userType]);

  useEffect(() => {
    stopBackgroundScrolling(true);
    onLoad && onLoad();
  }, []);

  return (
    <React.Fragment>
      <div className="modal-custom open">
        <div className="modal_dialog contract_modal">
          <div className="modal_content">
            {customPopupTitle && (
              <div className="modal_header">
                <h5>{customPopupTitle}</h5>
              </div>
            )}
            <div className="modal_body">
              {customPopupMsg && <div className={`plan_condition custom-modal-dec ${!submitOrderPopup ? 'bottom-space' : ''}`}>{customPopupMsg}</div>}
              {submitOrderPopup && (
                <div
                  className="plan_condition custom-modal-dec bottom-space"
                  style={{
                    paddingTop: 24
                  }}
                >
                  <Checkbox checked={checked} onChange={onCheckBoxChange}>
                    <span className="check_text">I confirm that I am authorised to place the order on behalf of the company.</span>
                  </Checkbox>
                </div>
              )}
              <div
                className="next_step"
                style={{
                  width: '100%',
                  padding: '0 24px'
                }}
              >
                <Button
                  disabled={loading}
                  variant="outlinebtn"
                  onClick={closeCustomModal}
                  style={{
                    marginRight: 20,
                    color: '#0C0F12',
                    padding: 5
                  }}
                >
                  Cancel
                </Button>
                <Button
                  disabled={loading || !checked}
                  variant="activebtn"
                  onClick={submitCustomModal}
                  style={{
                    padding: 5
                  }}
                >
                  {submitBtnName}
                  {loading && <span className="loading_icon"></span>}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomModal;
